import capitalizeFilter from '../../../filters/capitalize-filter';
import windowService from '../../../services/windowService';
import { NextAction } from '../models/nextAction';

export default function getTrainingAction(
  type: 'course' | 'pathway',
  trainingId: string,
  trainingProgress?: NextAction
) {
  const progressType = trainingProgress?.progress?._type;
  const assigned = !!trainingProgress?.instanceId;
  const route = assigned
    ? `#/training-steps/${trainingProgress.instanceId}?stepId=${trainingProgress.stepId}${
        type === 'pathway' ? '&isWorkflow=true' : ''
      }`
    : `#/add-to-your-training/${trainingId}`;

  const handleRedirect = () => {
    if (!assigned) {
      localStorage.setItem('routeBeforeSteps', window.location.hash);
    }
    windowService.redirectTo(route);
  };

  return {
    trainingActionText:
      (progressType === 'Started' ? 'Resume' : progressType === 'Finished' ? 'View' : 'Start') +
      ' ' +
      capitalizeFilter(type),
    handleRedirect,
  };
}
